import {createSelector} from '@reduxjs/toolkit'

const userAuthSelector = createSelector(
    [state => state.userAuth],
    (userAuth) => {
        return userAuth
    }
)

const userAuthSelect = state => ({
    userAuth: userAuthSelector(state)
})

export default userAuthSelect